import * as Styles from "./styles";

export function InfoText() {
  return (
    <Styles.Container>
      <p>
        Nesta seção, apresentamos os resultados do levantamento das condições
        socioeconômicas, de trabalho e saúde mental de profissionais da saúde do
        nordeste no contexto de pandemia da covid-19. Os profissionais
        responderam a um questionário on-line, disponível de novembro de 2020 a
        fevereiro de 2021. Os resultados completos podem ser acessados por meio
        do boletim{" "}
        <a
          target="_blank"
          rel="noreferrer noopener"
          href="https://drive.google.com/file/d/17l1T0-Mq6GIRBEDuqIepmgPL-q760QHa/view?usp=drivesdk"
        >
          disponível aqui.
        </a>
      </p>
    </Styles.Container>
  );
}
